"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Duration = void 0;
var Duration;
(function (Duration) {
    Duration["Short"] = "u-duration-short";
    Duration["Medium"] = "u-duration-medium";
    Duration["Long"] = "u-duration-long";
})(Duration = exports.Duration || (exports.Duration = {}));
//# sourceMappingURL=Duration.js.map